/* Native section controls. Kaching owns bundle quantities/discounts; do not fake package variants. */
(() => {
  if (window.__aloraNkEditableInstalled) return;
  window.__aloraNkEditableInstalled = true;
  const all = (selector,scope=document) => [...scope.querySelectorAll(selector)];
  const one = (selector,scope=document) => scope.querySelector(selector);
  function init(scope=document) {
    const sections=all('.alora-nk[data-nk-section]',scope);
    if(scope.matches?.('.alora-nk[data-nk-section]'))sections.unshift(scope);
    sections.forEach(section=>{
      if(section.dataset.nkInitialized==='true')return;
      section.dataset.nkInitialized='true';
      const gallery=one('[data-nk-gallery]',section);
      if(gallery){
        const slides=all('[data-nk-slide]',gallery),thumbs=all('[data-nk-thumb]',gallery);let selected=0;
        const show=index=>{if(!slides.length)return;selected=(index+slides.length)%slides.length;
          slides.forEach((slide,i)=>{slide.hidden=i!==selected;slide.setAttribute('aria-hidden',String(i!==selected));});
          thumbs.forEach((thumb,i)=>{if(i===selected)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current');});
          one('[data-nk-gallery-status]',gallery).textContent=`Image ${selected+1} of ${slides.length}`;
        };
        thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
        one('[data-nk-prev]',gallery)?.addEventListener('click',()=>show(selected-1));
        one('[data-nk-next]',gallery)?.addEventListener('click',()=>show(selected+1));
        let x=0;gallery.addEventListener('touchstart',e=>{x=e.changedTouches[0].clientX;},{passive:true});
        gallery.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-x;if(Math.abs(dx)>45)show(selected+(dx<0?1:-1));},{passive:true});
        section.addEventListener('nk:select-block',e=>{const i=slides.findIndex(slide=>slide.dataset.nkBlock===e.detail);if(i>=0)show(i);});
        show(0);
      }
      const form=one('[data-nk-form]',section);
      const offerPreviews=all('[data-nk-offer-preview]',section);
      offerPreviews.forEach(offer=>offer.addEventListener('click',()=>offerPreviews.forEach(other=>{other.classList.toggle('is-selected',other===offer);other.setAttribute('aria-checked',String(other===offer));})));
      if(form){
        const button=one('[name=add]',form),status=one('[data-nk-status]',form);
        const validProduct=section.dataset.productId===section.dataset.expectedProduct;
        const allowed=section.dataset.checkoutEnabled==='true'&&section.dataset.offerPreview!=='true'&&validProduct&&section.dataset.baseAvailable==='true';
        button.disabled=!allowed;button.setAttribute('aria-disabled',String(!allowed));
        if(allowed)status.hidden=true;
        // Capture only disabled drafts. Enabled forms remain standard Shopify forms so the native
        // Kaching app can apply its verified quantities, discounts, and subscription plan.
        form.addEventListener('submit',event=>{
          if(!allowed){event.preventDefault();event.stopImmediatePropagation();button.disabled=true;status.hidden=false;}
        },true);
        if(!allowed){const guard=new MutationObserver(()=>{if(!button.disabled)button.disabled=true;});guard.observe(button,{attributes:true,attributeFilter:['disabled']});section._nkGuard=guard;}
      }
      all('.faq details,.pacc details',section).forEach(detail=>detail.addEventListener('toggle',()=>one('summary',detail)?.setAttribute('aria-expanded',String(detail.open))));
      all('.arrows',section).forEach(arrows=>{const rail=one('.rail',section);all('span',arrows).forEach((arrow,i)=>{
        arrow.tabIndex=0;arrow.setAttribute('role','button');arrow.setAttribute('aria-label',i?'Next customer stories':'Previous customer stories');
        const advance=()=>rail?.scrollBy({left:(i?1:-1)*((one('.rc',rail)?.getBoundingClientRect().width||300)+16),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        arrow.addEventListener('click',advance);arrow.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();advance();}});
      });});
      all('[data-nk-review-link]',section).forEach(link=>{if(link.getAttribute('href')==='#'){link.setAttribute('aria-disabled','true');link.addEventListener('click',e=>e.preventDefault());}});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>all('.alora-nk',e.target).forEach(section=>section._nkGuard?.disconnect()));
  document.addEventListener('shopify:block:select',e=>{
    const section=e.target.closest('.alora-nk');
    section?.dispatchEvent(new CustomEvent('nk:select-block',{detail:e.detail?.blockId}));
    const detail=e.target.closest('details');if(detail)detail.open=true;
  });
})();
